import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-rainfall-forecast',
	templateUrl: './rainfall-forecast.component.html',
	styleUrls: ['./rainfall-forecast.component.scss']
})
export class RainfallForecastComponent {
	@Input() rainfallAmount : number | undefined;
	@Input() rainfallChance : number | undefined;
}
